export default function renderAdrFooterV3(data) {
  return function (pdf) {
    let cursorY = 750;
    pdf.line(15, cursorY, 590, cursorY);
    cursorY += 2;
    pdf.line(15, cursorY, 590, cursorY);
    cursorY += 18;
    pdf.setFont("helvetica", "bold");
    pdf.text("ADA Notice", 35, cursorY);
    pdf.setFont("helvetica", "normal").setFontSize(9);
    pdf.text(
      "For individuals with sensory disabilities, this document is available in alternate formats. For information, call",
      110,
      cursorY - 5
    );
    pdf.text(
      "(916) 445-1233, TTY 711, or write to Records and Forms Management, 1120 N Street, MS-89, Sacramento, CA 95814.",
      110,
      cursorY + 5
    );
    this._setDefaults(pdf);
  };
}
